import { Routes } from '@angular/router'

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/around-me/around-me.page').then((m) => m.AroundMePage),
  },
  {
    path: 'points-of-interest',
    loadComponent: () =>
      import('./pages/points-of-interest/points-of-interest.page').then(
        (m) => m.PointsOfInterestPage
      ),
  },
  {
    path: 'itineraries',
    loadComponent: () =>
      import('./pages/itineraries/itineraries.page').then(
        (m) => m.ItinerariesPage
      ),
  },
  {
    path: 'itinerary-details-page',
    loadComponent: () =>
      import(
        './components/tours/itinerary-details-page/itinerary-details-page.page'
      ).then((m) => m.ItineraryDetailsPagePage),
  },
  {
    path: 'desktop-home',
    loadComponent: () =>
      import('./pages/around-me/around-me.page').then((m) => m.AroundMePage),
  },
]
